import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=28fd5673&scoped=true&"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&id=28fd5673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd5673",
  null
  
)

export default component.exports